import "../styles/sideform.css";

const SideFormWrapper = ({ children, toggleForm }) => {
  return (
    <div
      className={"side-form-wrapper"}
      onClick={(e) => {
        toggleForm(false);
      }}
    >
      {children}
    </div>
  );
};

export default SideFormWrapper;
